import React, { useCallback, useRef, useState } from 'react'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import toLower from 'lodash/toLower'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import FarmForm from '@galo-monitor/web-containers/forms/company/FarmForm'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

const FarmModal = (props) => {
  const {
    id,
    open,
    handleClose,
    farm,
    onSuccess
  } = props

  const [loading, setLoading] = useState(false)

  const t = useT()
  const { createDialog } = useDialog()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () => {
      formRef.current.submit()
    },
    []
  )

  const handleSuccess = useCallback(
    updatedFarmData => {
      handleClose()
      onSuccess(updatedFarmData)
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    () => {
      setLoading(false)
      createDialog({
        id: 'error-farm',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'female',
            action: toLower(t(isEmpty(farm) ? 'register' : 'update')),
            this: toLower(t('farm', { howMany: 1 }))
          })  }.`
        }
      })
    },
    [createDialog, farm, t]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ t('register of {this}', {
        this: t('{this} account', {
          howMany: 1,
          this: t('farm', { howMany: 1 })
        })
      }) }
      FooterComponent={ () => (
        <>
          <Button
            id="save"
            onClick={ handleConfirm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <FarmForm
        ref={ formRef }
        farm={ farm }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
      />
    </Modal>
  )
}

FarmModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  farm: PropTypes.object
}

FarmModal.defaultProps = {
  farm: {}
}

export default FarmModal
